export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 9.051,
        "transcript": "Aa, wiinga-w' iinga atauciukan aipaqngailkeka.",
        "translation": "Ah, I will not date him if he has one eye."
    },
    "2": {
        "startTime": 9.27,
        "endTime": 22.22,
        "transcript": "Aren tua-i cunaw' tang qanruskeng... qanruskengaini tamalkumta umyuarteq'lallrullinilriakut.",
        "translation": "I mean it turns out we thought the same thing to the ones he talked to."
    },
    "3": {
        "startTime": 22.939,
        "endTime": 31.463,
        "transcript": "Ukut-llu iluraanka cali tua-i tuaten umyuangqelallrulliniut wangtun.",
        "translation": "These cousins of mine had thought the same as I did."
    },
    "4": {
        "startTime": 32.567,
        "endTime": 39.567,
        "transcript": "Aren tua-i, tuaten tua-i ayuqu'rlulallruukut.",
        "translation": "That's all how we were, poorly."
    },
    "5": {
        "startTime": 39.999,
        "endTime": 50.729,
        "transcript": "Tua-i tamakut qanrucetemta qanrutkellrit asgurakvakarpek'naki, tau͡gaam ukvekluki.",
        "translation": "We believed what were told by speakers without doubting much of it."
    },
    "6": {
        "startTime": 53.632,
        "endTime": 67.162,
        "transcript": "Tayima una wani qanrucunailnguq. Qanrucunailnguut qaillun tamaani tangerrluki ciunerkait nallunrit'lallruitki?",
        "translation": "There are those who are hard to talk to.  How did they know by observation their journey ahead?"
    },
    "7": {
        "startTime": 67.683,
        "endTime": 80.054,
        "transcript": "Qanrucunailnguut qanrucaaqerraarluki qanruyutseng atunritaqatgu waten pilallruit imkut qalartetullret.",
        "translation": "The ones who were hard to talk to were talked to but when they didn't use their advice they would say this about them."
    },
    "8": {
        "startTime": 80.754,
        "endTime": 84.054,
        "transcript": "Aa, tua-i tuaten ayuquraa.",
        "translation": "Ah, be just the the way you are."
    },
    "9": {
        "startTime": 85.178,
        "endTime": 91.93,
        "transcript": "Umyuarpet assikekngaa tekiskuvgu angiciyaaqelarniartuten qanruyutevnek.",
        "translation": "When you reach in your mind something you like and take apart your advice."
    },
    "10": {
        "startTime": 92.95,
        "endTime": 105.512,
        "transcript": "Niitengerpet maligtaqutellrunriten elpenek qessanayularyaaqniartuten.",
        "translation": "You heard it, you didn't follow but wish you had."
    },
    "11": {
        "startTime": 105.804,
        "endTime": 112.162,
        "transcript": "Ca, camek, kitek ayuqeltassiigucirluku tangllerpenek tauna cali qanrutkeqerru.",
        "translation": "What, what is an example you can expound on it further."
    },
    "12": {
        "startTime": 112.476,
        "endTime": 116.312,
        "transcript": "Ca tangellren elpet, tangellren",
        "translation": "What did you see, you see"
    },
    "13": {
        "startTime": 116.75,
        "endTime": 119.94,
        "transcript": "tamakut qanrutek'lallrat elpet niilluki;",
        "translation": "hearing the advice of the speakers then"
    },
    "14": {
        "startTime": 121.337,
        "endTime": 125.003,
        "transcript": "cauga tauna wani, ayuqeltassiiguciqerluten?",
        "translation": "what is that with an example?"
    },
    "15": {
        "startTime": 126.447,
        "endTime": 130.34,
        "transcript": "Tua-i-wa, tauna-qaa qanrucunailnguq?",
        "translation": "Do you mean of one who is hard to talk to?"
    },
    "16": {
        "startTime": 130.431,
        "endTime": 132.971,
        "transcript": "Ii, qanrucunailnguq tuaten qanrutek'lallrat.",
        "translation": "Yes, the one who is hard to talk to as they mentioned of him."
    },
    "17": {
        "startTime": 133.463,
        "endTime": 137.268,
        "transcript": "Elpet iivkun tangerrluku tuatnalleq.",
        "translation": "You saw with your own eyes, one who did that."
    },
    "18": {
        "startTime": 137.507,
        "endTime": 142.268,
        "transcript": "Ca imna angi...ca taum angicugyaaqelallrua?",
        "translation": "What was it that he wanted to undo?"
    },
    "19": {
        "startTime": 142.907,
        "endTime": 153.317,
        "transcript": "Tua qanrucunailkelallrit tamaaggun tua-i niiteksaitelallratgun tangvalallruanka.",
        "translation": "The ones who were hard to talk to didn't listen and that's what I saw."
    },
    "20": {
        "startTime": 153.736,
        "endTime": 168.5,
        "transcript": "Nallunritellruanka yuk'egtauvkenateng ilameggnek ayuqniarluteng catulrianek pitulrianek ayuqniarluteng anrutamegteggun wall' qaimegteggun.",
        "translation": "I knew they were unhealthy, wanting to be able to do what other's can and will get done for their own stomach and body."
    },
    "21": {
        "startTime": 168.887,
        "endTime": 181.7,
        "transcript": "Yuulallruut tamakut qanruyutem artuqai. Tamakut ellmegnek maligtaqutenrilnguut qanruyutmeggnun.",
        "translation": "That's how they were with their advice they didn't heed.  Those who didn't listen on their own of given advice."
    },
    "22": {
        "startTime": 182.1,
        "endTime": 198.166,
        "transcript": "Nangteqluteng yuulallruut elluamiuvkenateng tua-i imkurluteng camek nuuqiuterluteng. Ca tamalkuan nuuqiutekluku.",
        "translation": "They lived sickly, not successful, well like they didn't have everything and lacked it all."
    },
    "23": {
        "startTime": 198.8,
        "endTime": 209.533,
        "transcript": "Tua-i, waten ak'anun-llu yuuyuunateng. Ak'anun unguvayuunateng tuaten umyuarteng aturluku yuulriit.",
        "translation": "And, so they didn't live long.  They didn't live long those who followed their own mind and action."
    },
    "24": {
        "startTime": 210.319,
        "endTime": 226.833,
        "transcript": "Ak'anun unguvayuunateng. Tang ilumun tua-i piciutacia au͡gkut qanrutkelallrat. Ak'anun unguvayuunateng. Tua-i naullungualukarluteng yuunriqerraqluteng catairtaqluteng.",
        "translation": "They didn't live long.  See,truly it's very correct what they use to tell us.  They didn't live long.  They didn't live long.  They would be sickly and suddenly they're gone."
    },
    "25": {
        "startTime": 227.798,
        "endTime": 239.766,
        "transcript": "Maa-i, maa-i ernerput, ernerput wani, ernerput tekitan, una wani tekitan. Kitak ernemteńi maa-i",
        "translation": "Now, now today today so you've arrived at today.  In this day and age now,"
    },
    "26": {
        "startTime": 240.268,
        "endTime": 255.399,
        "transcript": "murilkellerpeni ak'a avani, tayima yuunertunruqalalliut. Qaillun cangallrua elpeni qanrucunailnguq ernemteńi yuullra?",
        "translation": "with your observation of the distant past on longevity.  On those who hard to talk to, are they any different living today?"
    },
    "27": {
        "startTime": 257.233,
        "endTime": 268.75,
        "transcript": "Ernemteńi-qaa? Ya, ernemteńi waniwa wangkuta elpet wiinga ernemegni, cukanruutqaa catairutellrat wall'u-qaa qaill' ayuqa?",
        "translation": "Today?  Yes, in our day, for us today are they dying faster or how is it?"
    },
    "28": {
        "startTime": 268.834,
        "endTime": 279.8,
        "transcript": "Tua-i cukanruluteng tamakut qanrucunailnguut imkuni qanruyutmeggnun maligtaqutellriani cukanruluteng.",
        "translation": "(Living) It is faster on the ones hard to talk to, faster than the ones who follow their advice."
    },
    "29": {
        "startTime": 280.242,
        "endTime": 296.1,
        "transcript": "Cukanruluteng. Man'a-llu yuugurallrat cukanruluni. Arnat arnaurteturnirluteng wall'u angutait-llu angutngurteturnirluteng. Tangrriu.",
        "translation": "They are faster. Their living is faster.  Faster on aging for women and of men aging faster.  You see (it)."
    },
    "30": {
        "startTime": 297.846,
        "endTime": 306.567,
        "transcript": "Tua-i waten ayuquq man'a. Tuaten tua-i... cukatatkevkenateng.",
        "translation": "That's how it is on this.  Like that...going at different pace."
    },
    "31": {
        "startTime": 306.791,
        "endTime": 323.066,
        "transcript": "Tau͡gken imkut qanruyutmeggnun maligtaququrautellriit yuullrat man'a cukavkenani tuar ayuqelria. Cukavkenani ayuqelriarulriatun ayuqluni.",
        "translation": "However, those who heed and follow their advice go through it slowly or so it seems.  Slowly or it is that way."
    },
    "32": {
        "startTime": 323.493,
        "endTime": 339.033,
        "transcript": "Tangerrluku. Tua-i waniwa tua-i. Icivaq-llam ing'um ataurlurpeci-am piicaucarturturalaraanga tekiartaqami Kangirnamun.",
        "translation": "You see it.  Anyway, awhile back that poor father of yours prays... he comes to pray for me when he arrives in Kongignak all the time."
    },
    "33": {
        "startTime": 339.951,
        "endTime": 361.3,
        "transcript": "Tua-i piicaucarturlua-am itlermini tua-i quyaurlulria cakneq. \"Aling ilungaurluuq quyanaqvaa tanem tangellren tauna tua-i umyuarpenek-am tuar tua-i utumaluten yuulalriaten. Tangellren quyanaqluni.\" Pilaraanga-am.",
        "translation": "When he came in to pray for me he said to me gratefully, \"My poor cousin, I'm grateful you're looking good and shows your mind is well. Thankful you look good.\""
    },
    "34": {
        "startTime": 361.818,
        "endTime": 382.966,
        "transcript": "Pila'arqa, \"Tua-i niitelalqa aturluku waniwa ayuqeqcaaralarnilua. Wiinga-llu aliayulqa maliggluku yuukuma, tua-i wangnek pingaitelliniama. Imkut tau͡gaam ayagcianka nangtarkaulliniamki.\"",
        "translation": "I tell him, \"I use what I heard to be as I am.  If I live with my loneliness I will not do anything for myself.  I'll only hurt the ones who I leaned on for deep support."
    },
    "35": {
        "startTime": 383.603,
        "endTime": 397.466,
        "transcript": "Waten nangteqelqa maliggluku yuukuma nangtarkaulliniamki. Waniw' tua-i waten canrilngurnun ugglua umyuameggnek utumalrianek.",
        "translation": "If I lived in pain, I would put them in pain also.  Now I bring myself up to where the ones who have cared for themselves mentally."
    },
    "36": {
        "startTime": 397.869,
        "endTime": 406.466,
        "transcript": "Utumalriit uggvikluki. Waniw' tua-i ayuquralarnilua waten elliryaaqengerma naparma.",
        "translation": "I find self care on top of it.  I am how I am even though I'm where I am standing."
    },
    "37": {
        "startTime": 407.124,
        "endTime": 419.533,
        "transcript": "Tua-i-gguq, ilumun. Yuum ayuqucia tua-i ava-i maniqerniluku-am qanertuq. Yuum-gguq ayuqucia ilumun manian.",
        "translation": "He said, \"Yes, exactly. You have presented what it's like for someone to be at.  Truly you have presented a persons life."
    },
    "38": {
        "startTime": 419.824,
        "endTime": 431.333,
        "transcript": "Ilii-gguq man'a yuum waten tua-i umyuami aliayullra maligtaquurpakarluku yuulria",
        "translation": "There could be someone who is lonely, gives into that"
    },
    "39": {
        "startTime": 431.706,
        "endTime": 446.466,
        "transcript": "aliayullni maligtaquurpakarluku yuulria egilrallra-llu cukalartuq. Ilumun tua-i ayuqucianek qanqaurlurtuq. Mikelnguuyaaqluni ingna.",
        "translation": "who gives up for loneliness goes through a fast journey.\"  His comment is exactly describing it.  He's still a child, that one."
    },
    "40": {
        "startTime": 447.054,
        "endTime": 456.799,
        "transcript": "Wangni mikelnguuyaaqluni tan'gaurluullra canimelnguq, canimecaaqelria. Piaqa-am, \"Tangerrluku,",
        "translation": "To me he's still a youngster, that's to me.  He was just a lad, recently.  I said to him, \"Look at that."
    },
    "41": {
        "startTime": 457.52,
        "endTime": 466.566,
        "transcript": "Tua-i wani-w' tangerqevnga. Caunricaaqelriaten-llu elpet. Cayaqlirluten-llu yuurtellruavet.",
        "translation": "As you see me right now.  You were born later finally no more or less."
    },
    "42": {
        "startTime": 467.03,
        "endTime": 479.999,
        "transcript": "Tua-i man'a maa-i qanruyukar waten taringecurlanrilngurmi uitaarkaucia-am waten neq'aqercet'laqen waten qanraqavet.",
        "translation": "You make me recall this short saying which stays with someone who didn't misunderstand it as you say that."
    },
    "43": {
        "startTime": 480.268,
        "endTime": 491.499,
        "transcript": "Atauwauguten. Kiirrarpet-llu napacin cali una napangucin angurrluk uuruteksaqunaku, ilungaurluu.\" pila'arqa-am.",
        "translation": "Very well.  And you know you're the only one living now, in no case don't regret your loss about that, my poor cousin.\"  I say to him."
    },
    "44": {
        "startTime": 492.387,
        "endTime": 505.699,
        "transcript": "\"Uuruteksaqunaku. Iqua tekicungkumteggu tua-i tekiskumteggu kingunrat-ggun imkut maligciiqapuk.\" Tua-i-am angqaurlulartuq qaill' pivkenani.",
        "translation": "\"Don't regret your loss that might have been prevented by appropriate action.\"  Poor, he say's 'yes' and nothing else."
    },
    "45": {
        "startTime": 521.417,
        "endTime": 535.458,
        "transcript": "Atauciq tayima elpet paiciucukngan wangkutnun kingunerpenun ca arcaqerluku elpet paiciucukngan qanrutkeqerru.",
        "translation": "If there's one to pass on to us who are behind you, can you tell us what you especially would pass on."
    },
    "46": {
        "startTime": 536.288,
        "endTime": 548.083,
        "transcript": "Tua-i waniwa au͡gkut ava-i qanrutkellrenka paiciutekpigainalriatun waniwa ayuqanka.",
        "translation": "What I have already said, I do consider that will be like true passing on."
    },
    "47": {
        "startTime": 548.658,
        "endTime": 569.749,
        "transcript": "Tua-i niisnganrilnguq qanruyutminun tua-i tuaten au͡gkucicetun ava-i niisnganrilngurtun ayuqeciquq. Niisnganrilngurtun ayuqeciquq cam nurluku, atu'urkaan nurluku",
        "translation": "Ones who don't listen lust like the ones before will be like the ones who didn't listen.  He will be like someone who doesn't listen who won't have what he needs."
    },
    "48": {
        "startTime": 570.952,
        "endTime": 586.374,
        "transcript": "Tua-i taugken imna nutaan qanrucunarqelria tua-i cali pik'a ciunrani paivngaqaaqluni. Ciunrani paivngaqaaqluni ayagpakarluni tekitaqluku.",
        "translation": "But, then there's one who is easy to talk to who will have blessing ahead of him.  It's available in his journey as he comes across it on his many travels."
    },
    "49": {
        "startTime": 587.04,
        "endTime": 595.916,
        "transcript": "Tuaten ayuqeciquq. Asgurtanrilnguq.",
        "translation": "That's how he will be if he does not doubt."
    },
    "50": {
        "startTime": 596.716,
        "endTime": 617.541,
        "transcript": "Asgurtalriit tau͡gaam qanruyutmeggnek tua-i tuaten ayuqelartut cam nurluki. Cam nurluki camek piicugluteng tua-i piilutiit piluni paivngayugpagluni.",
        "translation": "But those doubtful of their advice have not much of what they want,   They do experience more need and it stands out."
    },
    "51": {
        "startTime": 617.993,
        "endTime": 627.416,
        "transcript": "Cali man'a akusrarun maa-i ilaitnek yuut allurkengelriatun ayuqelartuq atu'urkaatnek.",
        "translation": "And on using (recreational drugs) nowadays it takes away from some people what they would have provided."
    },
    "52": {
        "startTime": 628.229,
        "endTime": 640.791,
        "transcript": "Tuar atuurkarteng akusrarcullermeggnun navrutaqluku. Navrulluku tua-i atu'urkarugateng imkut akusrarcullermeggnun tun'aqluki.",
        "translation": "Seems like they trade what they need to using, trading alot of useful items to fool around with it."
    },
    "53": {
        "startTime": 641.259,
        "endTime": 659.499,
        "transcript": "Akleng, cali maa-i akusrarculriit mat'umek apqiitnek taangamek mat'umek-llu kuingillermek, tuarpiaq tang imna tamatum imum aturyukngaata anguyakai.",
        "translation": "Poor thing! On using of recreational drugs/mistreatment using alcohol and smoking drugs consequently its like a warfare of self because of using them."
    },
    "54": {
        "startTime": 660.169,
        "endTime": 672.124,
        "transcript": "Tua-i ellmeggnek anernerteng-llu tunelriatun ayuqaqluku tamaaggun. Tua-i pillerkaa nurr' ukatairrluku tayim nalluyagutaqluteng.",
        "translation": "It's like they give up their life with that.  It wasn't their time to be unaware of themselves."
    },
    "55": {
        "startTime": 674.354,
        "endTime": 696.124,
        "transcript": "Maa-i tua-i yuut ayuquciqsaguskiit man'a, man'a maa-i taangaq kuingillermek-llu mat'umek aipirluku. Umyugaitnarqelria man'a atungnaqu'urluku. Ayuqelriit tua-i anernerteng kep'laqiit tamaaggun-llu.",
        "translation": "It's become a habit with that, this alcohol coupled with smoking drugs.  It's a foolish habit.  Their lives are cut off from that, too."
    },
    "56": {
        "startTime": 696.457,
        "endTime": 708.999,
        "transcript": "Imutun kepelriatun ayuqelaqiit. Qununaqsaaqaqluteng cakneq kingunrulriani. Qununaqsaaqaqluteng angtuamek.",
        "translation": "It's just like cutting it.  Its something one does not wish to part with for us left behind. Big but have to part with."
    },
    "57": {
        "startTime": 709.944,
        "endTime": 725.874,
        "transcript": "Tua-i waniw' maa-i mat'um nalliini mat'um atuqengamta nalliini yuut ayuquciqsaguskiit tamarmeng nunat yuita.",
        "translation": "Now at this time using to us has become a lifestyle by all of the village inhabitants."
    },
    "58": {
        "startTime": 726.423,
        "endTime": 735.124,
        "transcript": "Tamarmeng ellarpiim yuan atungnaqengluku man'a maa-i wagg'uq man' taangaq.",
        "translation": "All of the countries population...attempt to use this so called alcoholic beverage."
    },
    "59": {
        "startTime": 736.001,
        "endTime": 741.958,
        "transcript": "Wangkuta call' imumi ciungatni imumi taangatullruyaqukut arulatanek.",
        "translation": "Before them, we drank home brew."
    },
    "60": {
        "startTime": 743.003,
        "endTime": 759.333,
        "transcript": "Arulatanek taangatullruyaaqukut. Imna-llu wii aipaqa kass'anun ayaggaarluni-ll' tekitnaurtuq missuugmek uumek missuugpallermek tekiulluni papinek imalegmek.",
        "translation": "It was our alcoholic beverage.  My husband returned from white people and he arrived with a big bag full of potatoes."
    },
    "61": {
        "startTime": 760.663,
        "endTime": 773.833,
        "transcript": "Una-w', ukugnek-llu cali missuugegnek malrugnek saarralarpallraagnek imkugnek tekiutnaurtuq. Aipaa tuavet atuugarkauluni papinun.",
        "translation": "And he also came with two big bags of sugar and one of them was to be used in the potatoes."
    },
    "62": {
        "startTime": 775.146,
        "endTime": 786.958,
        "transcript": "Aren, wiinga-llu ciunrani wani kenirraarluki papit passiluki. Passirraarluki puckar' au͡g' imi'irqamku",
        "translation": "And me, there ready for his coming cooked and mashed those potatoes and after mashing when I filled the barrel..."
    },
    "63": {
        "startTime": 787.541,
        "endTime": 798.666,
        "transcript": "tua-i tuaten tua-i ayuqucirkaat nallunrirluku. Yuurqaaraat imkut umyuaqurluki imiraqluku puckaq imna.",
        "translation": "just like that I learned the process. I filled that barrel thinking of the drinks in containers."
    },
    "64": {
        "startTime": 799.952,
        "endTime": 807.124,
        "transcript": "Ayivrem-llu anrutaanek patuluku. Ketrirluku tua-i cagnilluku.",
        "translation": "I covered it with a seal intentine, tightening it with a cord."
    },
    "65": {
        "startTime": 808.021,
        "endTime": 817.416,
        "transcript": "Ketrirluku. Tua-i-ll' piqerluni imna puckam imna patua qerruryarturluni.",
        "translation": "It had a cord.  After awhile that cover of the barrel starts to inflate."
    },
    "66": {
        "startTime": 818.678,
        "endTime": 826.374,
        "transcript": "Qerruumaluni-ll' erenregni malrugni. Pingayurkaagni-ll' atraqanirluni.",
        "translation": "It is inflated for two days and its third day it comes down a little."
    },
    "67": {
        "startTime": 827.3,
        "endTime": 841.749,
        "transcript": "Tua-i atrarluni atraan ikirrnaurput, ikirrnaurput kit'elliinilriit imkut tayim papit. Mana-w' painga ecuitepiaq.",
        "translation": "So it goes down and once down we opened those potatoes had sunk to the bottom.  The top of it was very clear."
    },
    "68": {
        "startTime": 843.374,
        "endTime": 856.208,
        "transcript": "Aren, qaluuricirluku tua-i cat makut imirluki. Saaniiget-llu imirluki. Sanigpiit wall'u egatet imirluki. Patulget imirluki.",
        "translation": "Oh, we ladled it onto containers.  We filled tea kettles.  We filled big kettles and pots.  Filled them with covers."
    },
    "69": {
        "startTime": 857.104,
        "endTime": 865.708,
        "transcript": "Kingunra-ll' cali kan'a qalutnermek saarralirluku arulaarrluku. Ayagarrluni-llu.",
        "translation": "The rest of it we added and mixed with a cup of sugar.  It spread quickly."
    },
    "70": {
        "startTime": 866.464,
        "endTime": 880.708,
        "transcript": "Tamana tamakut-llu imkut aturluki tua-i aturluki arenqianateng tau͡gaam tua-i tuaten tua-i waten makucetun pitaluteng piksaitelallruut.",
        "translation": "And, so we used those and used them as it became what it was but they didn't get like these today."
    },
    "71": {
        "startTime": 881.355,
        "endTime": 892.833,
        "transcript": "Kenkutellrat cakaniutevkenani pilallruut. Equkutevkenateng. Assikluteng tau͡gaam. Assikulluteng.",
        "translation": "Their love didn't change.  They didn't hate.  But liked one another, like that."
    },
    "72": {
        "startTime": 895.208,
        "endTime": 910.708,
        "transcript": "Tua-i arulacinanri-ll'... caqerlua tua-i kia ua cakmani nunapigmi neqliuratullruamta. Caqerlua piaqa imna Acill'aq.",
        "translation": "So, we quit brew...one time I...we always cut fish down river on the tundra.  One time I said to that Acill'aq."
    },
    "73": {
        "startTime": 911.58,
        "endTime": 921.708,
        "transcript": "\"Tua-i wii waniw' kelengraatnga taangatulriit niisngairutua. Tua-i taqeqatartua. Amlleriuq atullra au͡g'um taangam.",
        "translation": "\"I am not going to go to my invites with drinkers.  I'm about to quit.  It's plenty that I used alcoholic drinks.\""
    },
    "74": {
        "startTime": 922.659,
        "endTime": 935.458,
        "transcript": "Tua-ll' pianga, \"Taqkuma-gguq ellii-ll' taqciquq.\" Tua-i taqlunuk tuani qanruyullunuk.",
        "translation": "He said to me.  \"If you quit, I will quit, too.\"  We quit then in by telling one another."
    },
    "75": {
        "startTime": 935.916,
        "endTime": 946.541,
        "transcript": "Tua-i kelengraitkuk-llu qakemkut ilangcinanrirluki. Catuqatalriit au͡gkut Caninermiut. Tua-i",
        "translation": "We had invitations but ignored them out there\"  They were about to have it, people of Canineq.  So there"
    },
    "76": {
        "startTime": 947.846,
        "endTime": 957.958,
        "transcript": "Wii tamaaken tua-i taqellruunga tua-i. Ak'aurtuq taqucilqa. Tamaani pinirpaglua yuullemni, yuullma nalliini.",
        "translation": "I quit from that point on.  I quit long ago.  I was still very strong living at that time."
    },
    "77": {
        "startTime": 959.078,
        "endTime": 971.791,
        "transcript": "Tua-i taqelqa ak'aqucu'urtuq tayima. Tua-i taqlunuk tamamegnuk. Tua-i tamatumek tua-i taqlunuk pitateklunuk.",
        "translation": "So, I quit a long long time ago.  We both were done with it at the same time."
    },
    "78": {
        "startTime": 972.622,
        "endTime": 985.458,
        "transcript": "Arenqiapakar, ilungaurluun pitsaqevkenak arnaarmek aipangkuvet. Umyuallgutekluni atam tau͡gaam uitauralleq, nutaan atam.",
        "translation": "Oh me, my dear cousin in case you have a lady partner it's a great idea to agree and be together."
    },
    "79": {
        "startTime": 986.42,
        "endTime": 991.041,
        "transcript": "Umyuallguteksagulluni aipaqutelleq, nutaan atam.",
        "translation": "To be in agreement as partners, it's a great thing."
    },
    "80": {
        "startTime": 992.376,
        "endTime": 1007.791,
        "transcript": "Tangerrluk wiingaurluq-llu waniwa aiparma imum tungiinun camek umyuarniurutaitellemnek quyapialalrianga watqapik. Quyatmek tau͡gaam.",
        "translation": "You see, my poor self is thankful having no regrets towards my previous partner.  Only gratefulness."
    },
    "81": {
        "startTime": 1008.372,
        "endTime": 1020.958,
        "transcript": "Umyuarteqaqlua-llu anirta maaten ciullegaanga anirta wii pisqutiinek narurtellrunritlemnek quyatengqelartua.",
        "translation": "I think of how fortunate after he went ahead of me how fortunate I didn't go against his order."
    },
    "82": {
        "startTime": 1021.86,
        "endTime": 1028.999,
        "transcript": "Anirta wii pisqutiinek narurtaarpek'naku aipaqellrulliniaqa tangvallemni.",
        "translation": "Thank goodness I was his partner hardly going against his order or command while I could see him."
    },
    "83": {
        "startTime": 1030.061,
        "endTime": 1039.666,
        "transcript": "Tamana tamaa-i quyatekluku narurtaarutevkenanuk ayuqellerpuk quyatekluku.",
        "translation": "I am thankful that we didn't go against each others will, so thankful."
    },
    "84": {
        "startTime": 1040.132,
        "endTime": 1050.208,
        "transcript": "Ellin-llu cali waniw', imumi waniw' cunaw' anerneriqatarluni. Wii qaill' piciinaku tangvangramku.",
        "translation": "He was also, at that time, he was about to leave his body.  I had no idea as I watched him."
    },
    "85": {
        "startTime": 1051.115,
        "endTime": 1060.291,
        "transcript": "Waten pianga. \"Akitai-gguq ingkut kitugteqerlaki. Qavarningami-gguq tua-i waniw' qavaqatartuq.\"",
        "translation": "He said to me, \"Fix my pillow over there.  I'm getting sleepy so I am going to sleep.\""
    },
    "86": {
        "startTime": 1061.247,
        "endTime": 1069.291,
        "transcript": "Waniw' akwaugaq atakuuluku pagaani qanrutkelaryaaqaa Jesus-aaq.",
        "translation": "Just yesterday in the evening, up above he'd say, 'Jesus'."
    },
    "87": {
        "startTime": 1070.16,
        "endTime": 1080.791,
        "transcript": "Yuk-gguq pag' pamaaranrilnguularpagta. Pagaa-i-gguq-am ayagtu'rtuq. Aciliurturluni. Una tua-i takuyarluku ayaagaraqlluni.",
        "translation": "To me that person up there is moving at such a a good speed.  He's is going above at a certain speed looking to area below.  He would look sideways turning his head."
    },
    "88": {
        "startTime": 1081.998,
        "endTime": 1093.333,
        "transcript": "Yuk-gguq pag' pamaqcuaranrilnguularpagta. Atakuuluku tuani una-am qanertuq, \"Jesus-aaq-gguq man'a itqatartuq.\"",
        "translation": "That person  It was evening at that time and he says, \"Jesus is coming in. \""
    },
    "89": {
        "startTime": 1093.842,
        "endTime": 1111.124,
        "transcript": "\"Itertuq-gguq\". Tua-i itran qalaruskii angnirluni cakneq Jesus-aaq. Tua-i tangvagluku qalaruskii tua-i. Piqerluni-ll' qanerluni, \"Ava-i-gguq-am tua-i an'uq.\"",
        "translation": "\"He came in.\"  When he came in, he talked to Jesus happily.  Shortly he said, \"He just left.\""
    },
    "90": {
        "startTime": 1113.598,
        "endTime": 1130.041,
        "transcript": "Aren tuani tua-i unuakumi anernerillruuq. Inarrluku. Inarqaarluku-ll' iquanun wii wavet aqumqerlua. Uligluku-llu inarcuan. Qavarningami-gguq waniw' qavaqatartuq.",
        "translation": "On that moring he stopped breathing.  He layed down.  After he laid down, I sat at the end of him.  I put a blanket on him when he wanted to lay down.  He said he was sleepy and will sleep."
    },
    "91": {
        "startTime": 1130.758,
        "endTime": 1147.333,
        "transcript": "Uyaquni mak'arrluki pianga. \"Tua-i usuurluuq, nalliini imumi aipaqsugluten aipaqsagutellruyaaqamken tau͡gaam-gguq tua-i waniw' qavarnigami qavaqatartuq.",
        "translation": "He perched his neck up and said to me, \"Poor you, I became your partner back in time because I wanted to but, I'm sleepy now and will go to sleep."
    },
    "92": {
        "startTime": 1148.212,
        "endTime": 1161.291,
        "transcript": "Qaillun-llu piqatallminek qaneqsaunani. Umyuarteqnaurtua waniw' aling aren unugpak-ggem qavallrungatuq. Piluku, kelluqurluku qavalaama.",
        "translation": "He never said what he was going to do.  I'd think, oh my I thought he slept all night.  I sleep attending to him."
    },
    "93": {
        "startTime": 1162.775,
        "endTime": 1178.083,
        "transcript": "Tua-i-tang anernerilria tua-i anernera qaskelliinaryartulria. Anerneni nucuggaarluku ancaaqnauraa. Igyaraani-llu watqapik nuagglugmek-lli cataitelar.",
        "translation": "I noticed his breathing was getting quiet.  He would breath in and would let it out.  His throat had no saliva whatsoever."
    },
    "94": {
        "startTime": 1179.216,
        "endTime": 1183.958,
        "transcript": "Aren tuar ilumun qavaryartulria tua-i qavaqerluni-llu.",
        "translation": "It seemed he was going to sleep and fell asleep."
    },
    "95": {
        "startTime": 1184.937,
        "endTime": 1192.708,
        "transcript": "Cunaw' im' tangvaurtelluni call' yug' im' ayagyuallminun uterrnaluni kegginaa.",
        "translation": "As he made me watch him, his face was about to return to look as he was young."
    },
    "96": {
        "startTime": 1193.458,
        "endTime": 1207.999,
        "transcript": "Kegginaqegtaari assipiaq. Tuar wani angukara'urluurrluni pinrilnguq. Kegginaqegtaari aspiaq. Tuar wani ayagyuaraq taklalria.",
        "translation": "The look on his face was very good.  As if he's not an old man anymore. His face was very good.  He layed there like a young person."
    },
    "97": {
        "startTime": 1212.037,
        "endTime": 1225.333,
        "transcript": "Cali imum ilungaurlurpet atani imna tua tum'artaa. Tuarpiaq atakumi waten pingayuni ernerni uani nem'i uitavkaatni.",
        "translation": "Also, your poor cousin he took to fix his body.  I believe they made him stay three nights in that downriver house."
    },
    "98": {
        "startTime": 1226.105,
        "endTime": 1231.958,
        "transcript": "Wani-ll' pingayuagnek atakuyartuan man'a agayuvigmun tagulluku.",
        "translation": "On the third day it was getting close to evening, he was brought to the church."
    },
    "99": {
        "startTime": 1232.749,
        "endTime": 1245.541,
        "transcript": "Unuaquan tagngamta tangrraqa. Aren, ilungaurluun imna ayagyuaqapiarallminun irniangeksaitellminun utertellinilria.",
        "translation": "The next day we went up and I saw, my, your cousin had returned to his youth when he had no children."
    },
    "100": {
        "startTime": 1246.114,
        "endTime": 1256.833,
        "transcript": "Nem'i-ll' uiallran assinerpaksagulluku. Ayagyuakaca... kia-kiq tayim' ayagyuakenritau tangertiin ayagyuakluku.",
        "translation": "He looked even better than how he looked at the house.  So youthful...who wouldn't think otherwise, how young he looked."
    },
    "101": {
        "startTime": 1257.458,
        "endTime": 1271.874,
        "transcript": "Tuar-gguq waniw' irniangeksaitellria-gguq tuar wani. Kegginaqegtaari tuar ilumun irniangeksaitellminum avavet utertellinilria. Assipiaq tangvallra.",
        "translation": "It was shared that he looked like when he didn't have any children.  His good look had returned to when he had no children.  It was very good to view him."
    },
    "102": {
        "startTime": 1272.527,
        "endTime": 1277.374,
        "transcript": "Tua-i tang tauna-ll' qaill' caqatauciinani ayuqellrullria.",
        "translation": "Oh that situation, we didn't know what was happening next."
    },
    "103": {
        "startTime": 1277.887,
        "endTime": 1288.124,
        "transcript": "Irniani-ll' ukut agayussuutnek, Agayunermi-ll' piami, agayussuutnek atuavkarluki waniw' cikiutell'uni.",
        "translation": "He had his children sing church songs because it happened on a Sunday as it came to closing of oneself."
    },
    "104": {
        "startTime": 1289.214,
        "endTime": 1295.958,
        "transcript": "Ug'um-wa ilungaurlurpet itgaikun cali tegumiaqurqii kanan' ketiini.",
        "translation": "Your other poor cousin was holding his feet below him."
    },
    "105": {
        "startTime": 1296.916,
        "endTime": 1302.749,
        "transcript": "Ukut-wa irniarin cali cikiulluku agayussuutnek cali atualriit.",
        "translation": "And, his other children were closed in on him and singing."
    },
    "106": {
        "startTime": 1303.472,
        "endTime": 1315.291,
        "transcript": "Tua-i-ll' taqluteng-am uitaqallratni waten pii. Arulaingqaqallratni. Imumek 'Aaliluyaamek' atuqerci.",
        "translation": "So, as they ended one song and stopped, he said to them, \"Sing that song, Aleluia.\""
    },
    "107": {
        "startTime": 1316.074,
        "endTime": 1323.916,
        "transcript": "Tua-i nallunrilamegteggu-am aturluku ugkut irniarin. Aturluku tua-i.",
        "translation": "So, they know the song all those children of his.  They sang it."
    },
    "108": {
        "startTime": 1325.045,
        "endTime": 1336.166,
        "transcript": "Iliit-am uyaqurrikun qes'arrluku waten pingnaurluq Apac'aaq. Maani irniartuumauq. Apac'aaq irniarin iliit.",
        "translation": "One of them held his neck with his arm, that poor Ap'ac.  She's here to have her baby.  Apac is one of his children."
    },
    "109": {
        "startTime": 1337.04,
        "endTime": 1343.416,
        "transcript": "Uyaqurrikun qes'arrluku. Cayukanirluku-am kegginaa igvartuq quuyuakacagaum...",
        "translation": "She embraced him around his neck and pulled him up for me to see his face, smiling."
    }
};